module.exports = __webpack_public_path__ + "static/media/eg.0b7d4713.svg";